import React, { useCallback, useEffect, useState } from "react";
import LoadingIcon from "../LoadingIcon";
import { Form } from "react-bootstrap";
import { Alert, Button, Snackbar } from "@mui/material";

const BankDetails = () => {
  const [loadingState, setLoadingState] = useState(false);
  const [user, setUser] = useState({});
  const [loading, setLoading] = useState(false);
  const [notificationType, setNotificationType] = useState("success");
  const [message, setMessage] = useState("");
  const [showNotification, setShowNotification] = useState(false);
  const token = localStorage.getItem("token");
  const vertical = "top";
  const horizontal = "center";

  const getDetails = useCallback(async () => {
    setLoadingState(true);
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}customerDetails`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          token,
        },
      }
    );

    const data = await response.json();

    setUser(data.User);
    setLoadingState(false);
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}update/customer/bank/${user._id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          token,
        },
        body: JSON.stringify({
          bankName: user.bankName,
          accountName: user.accountName,
          accountNumber: user.accountNumber,
          btcWallet: user.btcWallet,
          ethWallet: user.ethWallet,
          litecoinWallet: user.litecoinWallet,
        }),
      }
    );

    const data = await response.json();

    setShowNotification(true);
    if (data.status) {
      setNotificationType("success");
    } else {
      setNotificationType("error");
    }
    setMessage(data.message);
    setLoading(false);
    setTimeout(() => setShowNotification(false), 4000);
  };

  const handleChange = (e) => {
    setUser((prev) => {
      return {
        ...prev,
        [e.target.name]: e.target.value,
      };
    });
  };

  useEffect(() => {
    getDetails();
  }, [getDetails]);
  return (
    <div className="p-2">
      {loadingState ? (
        <div className="h-screen flex items-center justify-center">
          <LoadingIcon />
        </div>
      ) : (
        <div>
          <Form onSubmit={handleSubmit}>
            <Snackbar
              open={showNotification}
              autoHideDuration={6000}
              anchorOrigin={{ vertical, horizontal }}
            >
              <Alert message={message} severity={notificationType}>
                {message}
              </Alert>
            </Snackbar>
            <div className="row">
              <div className="col-md-12 mb-2">
                <Form.Group controlId="bankName">
                  <Form.Label>Bank Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Bank Name"
                    value={user.bankName}
                    onChange={handleChange}
                    name="bankName"
                  />
                </Form.Group>
              </div>
              <div className="col-md-12 mb-2">
                <Form.Group controlId="accountName">
                  <Form.Label>Account Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Account Name"
                    value={user.accountName}
                    onChange={handleChange}
                    name="accountName"
                  />
                </Form.Group>
              </div>
              <div className="col-md-12 mb-2">
                <Form.Group controlId="accountNumber">
                  <Form.Label>Account Number</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Account Number"
                    value={user.accountNumber}
                    onChange={handleChange}
                    name="accountNumber"
                  />
                </Form.Group>
              </div>
              <div className="col-md-12 mb-2">
                <Form.Group controlId="btcWallet">
                  <Form.Label>Bitcoin Wallet</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Bitcoin Wallet"
                    value={user.btcWallet}
                    onChange={handleChange}
                    name="btcWallet"
                  />
                </Form.Group>
              </div>
              <div className="col-md-12 mb-2">
                <Form.Group controlId="ethWallet">
                  <Form.Label>Ethereum Wallet</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Ethereum Wallet"
                    value={user.ethWallet}
                    onChange={handleChange}
                    name="ethWallet"
                  />
                </Form.Group>
              </div>
              <div className="col-md-12 mb-4">
                <Form.Group controlId="litecoinWallet">
                  <Form.Label>Litecoin Wallet</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Litecoin Wallet"
                    value={user.litecoinWallet}
                    onChange={handleChange}
                    name="litecoinWallet"
                  />
                </Form.Group>
              </div>
              <div className="d-grid gap-2">
                {loading ? (
                  <Button
                    sx={{
                      "& .MuiCircularProgress-root": {
                        height: "23px !important",
                        width: "23px !important",
                      },
                    }}
                  >
                    <LoadingIcon />
                  </Button>
                ) : (
                  <Button
                    type="submit"
                    variant="contained"
                    className="!bg-[#101010]"
                  >
                    Save
                  </Button>
                )}
              </div>
            </div>
          </Form>
        </div>
      )}
    </div>
  );
};

export default BankDetails;
